// extracted by mini-css-extract-plugin
export default {"footer":"r_cv","footerColumns":"r_cH","menuColumn":"r_cJ","legal":"r_cK","trademarks":"r_cL"};